import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MultiselectItem, Multiselect } from '../../../core/interfaces/admin.interface';
import { PortalService } from '../../../core/services/portal.service';
import { MULTI_SELECT_SETTING, EMULTI_SELECT_SETTING } from '../../../core/settings/settings.service';

@Component({
  selector: 'sacbo-user-select',
  templateUrl: './user-select.component.html',
  styleUrls: ['./user-select.component.scss']
})
export class UserSelectComponent {

  @Input() userSelected: MultiselectItem[] = [];

  @Output() userSelectedChange = new EventEmitter< MultiselectItem[]>();
  @Output() onSelected = new EventEmitter< MultiselectItem[]>();

  protected readonly multiselectSettings = MULTI_SELECT_SETTING;
  protected readonly EMULTI_SELECT_SETTING = EMULTI_SELECT_SETTING;

  usersList: MultiselectItem[] = [];

  constructor(
    public portalService: PortalService,
  ) { }

  onUserSelect(): void {
    this.userSelectedChange.emit(this.userSelected);
    this.onSelected.emit(this.userSelected);
  }

  load() {
    this.portalService.getMultiselectItems(Multiselect.EMAIL).subscribe((response) => {
      this.usersList = response?.data.map(user => {
        return {
          id: user.id,
          itemName: user.name
        } as MultiselectItem
      });
    }, (error) => {
      console.log("errore", error);
    });
  }

}
